module.exports = __webpack_public_path__ + "830bf32e2c31268f736be0a29a7039bb.MP3";